import React, {Component} from 'react'
import {Card} from 'react-bootstrap';
import ForgotPasswordForm from "./Forms/ForgotPasswordForm";
import ForgotPasswordSuccess from "./ForgotPasswordSuccess";
import {userForgetPassword, userSignIn} from "../../../store/actions/AuthActions";
import {connect} from "react-redux";
import SignInForm from "./Forms/SignIn/SignInForm";
import * as Swal from "sweetalert2";
import {forgetPasswordTypes} from "../../../store/actions/AuthActions/AuthActionsTypes/ForgetPasswordActionsTypes";

class ForgotPassword extends Component {

    state = {
        success: false,
    }

    changeStatusForm = (stauts) => {
        this.setState({
            success: stauts
        })
    }

    render() {
        const {loading, success, errors, forgetPassword} = this.props;

        return (
            <Card>
                {
                    success
                        ? <ForgotPasswordSuccess/>
                        : <ForgotPasswordForm
                            changeStatusForm={this.changeStatusForm}
                            loading={loading}
                            onSubmit={forgetPassword}
                            errors={errors}
                        />
                }
            </Card>
        )
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        const {errors} = this.props;

        const Toast = Swal.mixin({
            toast: true, position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        const errorMessage = errors[forgetPasswordTypes.GENERAL_ERROR]
            ? errors[forgetPasswordTypes.GENERAL_ERROR] :
            errors[forgetPasswordTypes.UNKNOWN_ERROR];

        if (errorMessage) {
            Toast.fire({icon: 'error', title: errorMessage});
        }
    }
}


const mapStateToProps = state => {
    return {
        success: state.auth.forgetPassword.success,
        loading: state.auth.forgetPassword.loading,
        errors: state.auth.errors.forgetPassword,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        forgetPassword: (user) => dispatch(userForgetPassword(user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
